// ============================================================
// HABIT OS — Bibliothek: Rezepte & Morgen-Drinks
// Shots · Morning Drinks · Frühstücks-Rezepte
// ============================================================

export const LIBRARY_RECIPES = {
  id: "recipes",
  label: "Rezepte & Drinks",
  icon: "🥤",
  subcategories: [

    // ── SHOTS & KONZENTRATE ──────────────────
    {
      id: "recipes_shots",
      label: "Shots & Konzentrate",
      icon: "⚡",
      habits: [
        {
          id: "hab_turmeric_shot",
          label: "Kurkuma-Zitronen-Salz-Shot",
          time: "morning",
          icon: "🌿",
          why: "Ein würziger Morgen-Shot aus Kurkuma, Zitrone, Pfeffer und Salz.",
          source: "Shoba et al., Planta Medica, 1998 · Prasad & Aggarwal, Herbal Medicine, 2011",
          dose: "1 TL Kurkuma, Saft ½ Zitrone, Prise Salz und Pfeffer in 60 ml warmem Wasser. Bei Leber- oder Gallenerkrankungen bzw. Medikamenten vorher ärztlich abklären.",
        },
        {
          id: "hab_beetroot_ginger_shot",
          label: "Rote-Bete-Ingwer-Shot",
          time: "morning",
          icon: "🫐",
          why: "Rote Bete enthält natürlich Nitrat, Ingwer sorgt für Schärfe.",
          source: "Lundberg et al., Nature Reviews Drug Discovery, 2008 · Black et al., American Journal of Chinese Medicine, 2010",
          dose: "Rezept für 2 Shots: 150 g rote Bete (entsaftet) · 30 g Ingwer (entsaftet) · Saft 1/2 Zitrone · Prise Cayennepfeffer. Täglich morgens, 2–3 Std. vor dem Training.",
        },
        {
          id: "hab_ginger_lemon_honey",
          label: "Ingwer-Zitronen-Honig-Shot",
          time: "morning",
          icon: "🍯",
          why: "Ein wärmender Shot aus frischem Ingwer, Zitrone und Honig. Zitrone liefert Vitamin C.",
          source: "Chang et al., Journal of Ethnopharmacology, 2013 · Bogdanov et al., Journal of Apicultural Research, 2008",
          dose: "Rezept: 30g frischer Ingwer (gerieben) · Saft 1 Zitrone · 1 TL roher Manuka-Honig · 100 ml warmes (nicht heißes) Wasser. 3–4x pro Woche.",
        },
        {
          id: "hab_apple_cider_vinegar",
          label: "Apfelessig-Shot",
          time: "morning",
          icon: "🍏",
          why: "Apfelessig ist ein traditionelles Hausmittel. Immer verdünnt und mit Strohhalm trinken, um den Zahnschmelz zu schonen.",
          source: "Johnston et al., Diabetes Care, 2004 · Khezri et al., Journal of Functional Foods, 2018",
          dose: "Rezept: 1–2 EL roher Apfelessig (mit 'The Mother') · 200 ml Wasser · optional: 1 TL Honig, Prise Zimt. Morgens vor dem Frühstück, Strohhalm benutzen!",
        },
      ],
    },

    // ── MORNING DRINKS ───────────────────────
    {
      id: "recipes_morning_drinks",
      label: "Morning Drinks",
      icon: "☕",
      habits: [
        {
          id: "hab_adaptogen_coffee",
          label: "Kaffee mit Pilzpulver",
          time: "morning",
          icon: "☕",
          why: "Kaffee mit Pilzpulvern wie Lion's Mane oder Reishi ist eine Geschmacksvariante. Gesicherte Wirkungen sind nicht belegt.",
          source: "Mori et al., Phytotherapy Research, 2009 · Chandrasekhar et al., Indian Journal of Psychological Medicine, 2012",
          dose: "1 Espresso, Pilzpulver laut Herstellerangabe. Bei Medikamenten, Schwangerschaft oder Stillzeit vorher ärztlich abklären.",
        },
        {
          id: "hab_collagen_latte",
          label: "Collagen Morning Latte",
          time: "morning",
          icon: "🥛",
          why: "Ein warmer, cremiger Drink mit Kollagen-Peptiden und Pflanzenmilch. Vitamin C aus Obst trägt zu einer normalen Kollagenbildung für eine normale Funktion der Haut bei.",
          source: "Proksch et al., Skin Pharmacology and Physiology, 2014 · Bolke et al., Nutrients, 2019",
          dose: "200 ml warme Hafer- oder Mandelmilch, Kollagen laut Herstellerangabe, 1 TL MCT-Öl, ½ TL Vanille.",
        },
        {
          id: "hab_golden_milk",
          label: "Golden Milk (Kurkuma-Latte)",
          time: "night",
          icon: "🌙",
          why: "Goldene Milch ist ein traditionelles Gewürzgetränk. Warm am Abend getrunken eignet sie sich als Ritual zum Runterfahren.",
          source: "Hewlings & Kalman, Foods, 2017 · Gupta et al., Biofactors, 2013",
          dose: "Rezept: 300 ml Kokosmilch (aus der Dose, verdünnt) · 1 TL Kurkuma · 1/4 TL schwarzer Pfeffer · 1/2 TL Ingwer · 1/4 TL Zimt · 1 TL Kokosöl · 1 TL Honig. Erwärmen, nicht kochen.",
        },
        {
          id: "hab_electrolyte_diy",
          label: "DIY Elektrolyt-Wasser",
          time: "morning",
          icon: "⚡",
          why: "Kommerzielle Sportgetränke enthalten oft zu viel Zucker und künstliche Farbstoffe. Dieses selbst gemachte Elektrolyt-Wasser liefert alle drei Schlüssel-Elektrolyte in optimalen Verhältnissen: Natrium (Hydrostation, neuronale Funktion), Kalium (Herzrhythmus, Muskelkontraktion) und Magnesium (über 300 enzymatische Reaktionen). Morgens getrunken rehydriert es den Körper nach dem Schlafen optimal.",
          source: "DiNicolantonio & O'Keefe, Open Heart, 2017 · Huberman Lab, Foundational Fitness Protocol",
          dose: "500 ml Wasser, ¼ TL Salz, Saft ½ Zitrone, optional 1 TL Honig. Bei Nieren- oder Herzerkrankungen bzw. Bluthochdruck vorher ärztlich abklären.",
        },
        {
          id: "hab_matcha_latte",
          label: "Matcha Latte",
          time: "morning",
          icon: "🍵",
          why: "Matcha enthält Koffein und L-Theanin.",
          source: "Nobre et al., Nutritional Neuroscience, 2008 · Weiss & Anderton, Journal of Chromatography, 2003",
          dose: "Rezept: 1–2 TL Ceremony-Grade Matcha · 60 ml heißes Wasser (70–80°C, nicht kochend) · aufschäumen · 150 ml Hafer- oder Mandelmilch dazu · optional: 1 TL Honig.",
        },
      ],
    },

    // ── FRÜHSTÜCKS-REZEPTE ───────────────────
    {
      id: "recipes_breakfast",
      label: "Frühstücks-Rezepte",
      icon: "🍳",
      habits: [
        {
          id: "hab_overnight_oats",
          label: "High-Protein Overnight Oats",
          time: "morning",
          icon: "🥣",
          why: "Hafer liefert den Ballaststoff Beta-Glucan, Chiasamen und griechischer Joghurt ergänzen Ballaststoffe und Protein. Blaubeeren bringen Geschmack und Anthocyane.",
          source: "Wolever et al., Journal of Nutrition, 1991 · Leidy et al., American Journal of Clinical Nutrition, 2013",
          dose: "Rezept (Abends vorbereiten): 80 g Haferflocken · 200 ml Hafermilch · 150 g griechischer Joghurt (0%) · 1 EL Chiasamen · 1 Messlöffel Vanilla-Protein · 100 g Blaubeeren · 1 TL Honig. 8 Std. quellen lassen.",
        },
        {
          id: "hab_egg_avocado_bowl",
          label: "Egg & Avocado Power Bowl",
          time: "morning",
          icon: "🥑",
          why: "Diese Bowl liefert alle Makronährstoffe im optimalen Frühstücks-Verhältnis: Eier (vollständiges Aminosäureprofil, Cholin für Gehirnfunktion und Acetylcholin-Synthese), Avocado (einfach ungesättigte Fettsäuren + Kalium), Lachs (Omega-3 + Vitamin D + Protein) und Spinat (Nitrate für Durchblutung + Folat). Das Cholin aus Eiern ist besonders important: 90% der Menschen konsumieren zu wenig.",
          source: "Zeisel & da Costa, Nutrition Reviews, 2009 · Attia P., Outlive, 2023",
          dose: "Rezept: 3 Eier (pochiert oder rührei) · 1/2 Avocado · 80 g Räucherlachs · Handvoll Spinat · Olivenöl · Zitronensaft · Meersalz · optional: Kapern.",
        },
        {
          id: "hab_chia_pudding",
          label: "Kurkuma-Chia-Pudding",
          time: "morning",
          icon: "🌿",
          why: "Chiasamen liefern Ballaststoffe und die pflanzliche Omega-3-Fettsäure ALA.",
          source: "Vuksan et al., European Journal of Clinical Nutrition, 2010 · Campos-Vega et al., LWT - Food Science, 2019",
          dose: "Rezept (Abends): 40 g Chiasamen · 300 ml Kokosmilch · 1 TL Kurkuma · 1/2 TL Ingwer · Prise schwarzer Pfeffer · 1 TL Ahornsirup. 8 Std. quellen. Morgens: Mango + Granatapfelkerne drauf.",
        },
        {
          id: "hab_protein_pancakes",
          label: "Protein-Pancakes (2 Zutaten)",
          time: "morning",
          icon: "🥞",
          why: "Pancakes aus Banane und Eiern kommen ohne Mehl aus und liefern Protein.",
          source: "Leidy et al., AJCN, 2013 · Zeisel & da Costa, Nutrition Reviews, 2009",
          dose: "Rezept: 2 reife Bananen (zerdrückt) + 3 Eier + 1 Messlöffel Protein-Pulver + Prise Zimt. Backen. Topping: griechischer Joghurt + Blaubeeren + Honig.",
        },
        {
          id: "hab_savory_oatmeal",
          label: "Herzhafter Hafer (Savory Oats)",
          time: "morning",
          icon: "🍳",
          why: "Herzhafter Hafer mit Ei und Gemüse ist eine zuckerarme Frühstücksvariante.",
          source: "Wolever et al., Journal of Nutrition, 1991 · Robertson et al., Diabetologia, 2003",
          dose: "Rezept: 80 g Haferflocken in Gemüsebrühe kochen · 1 pochiertes Ei drauf · 1/4 Avocado · Cherry-Tomaten · Rucola · Olivenöl · Meersalz · Chili-Flocken.",
        },
      ],
    },

    // ── ABEND-DRINKS ─────────────────────────
    {
      id: "recipes_evening",
      label: "Abend-Drinks & Wind-Down",
      icon: "🌙",
      habits: [
        {
          id: "hab_chamomile_blend",
          label: "Abend-Tee (Kamille + Lavendel)",
          time: "night",
          icon: "🌼",
          why: "Kräutertee aus Kamille und Lavendel ist ein klassisches Abendritual.",
          source: "Zick et al., Journal of Advanced Nursing, 2011 · Bent et al., American Journal of Medicine, 2006",
          dose: "Rezept: 1 TL Kamille + 1/2 TL Lavendel · 250 ml heißes Wasser · 10 Min. ziehen lassen · 1 TL Honig · 30–60 Min. vor dem Schlafen.",
        },
        {
          id: "hab_magnesium_drink",
          label: "Magnesium-Drink am Abend",
          time: "night",
          icon: "🫧",
          why: "Magnesium trägt zu einer normalen Muskel- und Nervenfunktion bei.",
          source: "Abbasi et al., Journal of Research in Medical Sciences, 2012 · Slutsky et al., Neuron, 2010",
          dose: "Magnesium-Pulver laut Herstellerangabe in 200 ml warmem Wasser.",
        },
        {
          id: "hab_tart_cherry_juice",
          label: "Sauerkirschen-Saft",
          time: "night",
          icon: "🍒",
          why: "Sauerkirschen enthalten natürlicherweise geringe Mengen Melatonin. Ein Glas Saft kann Teil einer Abendroutine sein.",
          source: "Pigeon et al., Journal of Medicinal Food, 2010 · Howatson et al., European Journal of Nutrition, 2012",
          dose: "240 ml reiner Sauerkirschen-Saft (kein Cocktail-Mix), 30–60 Min. vor dem Schlafen",
        },
      ],
    },
  ],
};